import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";

// Read-only "How to help me" card (supporter page and member preview)
export const HelpCardBody = ({ card, name }) => (
  <div className="space-y-4 text-[#3A2E4F]">
    {card.struggling && <div><div className="text-xs font-bold uppercase tracking-wider text-mm-primary">When I'm struggling, it helps if you…</div><p className="mt-1 whitespace-pre-wrap break-words" data-testid="help-card-struggling">{card.struggling}</p></div>}
    {card.dont && <div><div className="text-xs font-bold uppercase tracking-wider text-[#B23A63]">Please don't…</div><p className="mt-1 whitespace-pre-wrap break-words" data-testid="help-card-dont">{card.dont}</p></div>}
    {(card.helpers.length > 0 || card.own.length > 0) && (
      <div><div className="text-xs font-bold uppercase tracking-wider text-[#2F7A45]">What usually helps {name}</div>
        <ul className="mt-1 space-y-1" data-testid="help-card-helpers">
          {card.helpers.map((h) => <li key={h.title}>🌱 {h.title}{h.when && <span className="text-mm-muted">, especially {h.when}</span>}</li>)}
          {card.own.map((o) => <li key={o} className="break-words">🌱 {o}</li>)}
        </ul></div>
    )}
    {card.warnings.length > 0 && (
      <div><div className="text-xs font-bold uppercase tracking-wider text-[#8A6A12]">Early signs a check-in might help</div>
        <ul className="mt-1 space-y-1" data-testid="help-card-warnings">{card.warnings.map((w) => <li key={w}>🌤️ {w}</li>)}</ul></div>
    )}
  </div>
);

export const SupporterHelpCard = ({ token, name }) => {
  const [card, setCard] = useState(null);
  useEffect(() => { api.get(`/supporters/view/${token}/help-card`).then((r) => setCard(r.data.card)).catch((e) => logError("Help card failed:", e)); }, [token]);
  if (!card) return null;
  return (
    <section className="rounded-3xl p-6 bg-gradient-to-br from-[#F3EEFC] to-[#E9F6EC] border border-mm-primary/10" data-testid="supporter-help-card">
      <h2 className="font-bold text-lg">💜 How to help {name}</h2>
      <p className="text-sm text-mm-muted mt-1 mb-4">{name} made this card from their own playbook, so you know what really helps.</p>
      <HelpCardBody card={card} name={name} />
    </section>
  );
};
